import { render } from "./ProjectPromoItem.vue?vue&type=template&id=4d9d55e0"
import script from "./ProjectPromoItem.vue?vue&type=script&lang=js"
export * from "./ProjectPromoItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__